
import Vue from "vue";
import store from "@/store";
import { APPLICATION } from "@/store/applications";
import { createNamespacedHelpers } from "vuex";
import { IApplicationState } from "@/store/applications/types";
import { ReferenceDataType } from "@/store/referenceData/types";
import { getReferenceDataDescription } from "@/helpers/referenceData";

const { mapGetters, mapState } = createNamespacedHelpers(
  APPLICATION.NAME_SPACE
);

export default Vue.extend({
  methods: {},
  data() {
    return {};
  },
  computed: {
    collectionManager() {
      const promoCollectionManagerType =
        store.state.promoOffer.promoCode &&
        store.state.promoOffer.promoCode.collectionManager;

      const standardCollectionManagerType =
        store.state.standardOffer.offer &&
        store.state.standardOffer.offer.collectionManager;

      const collectionManagerType =
        promoCollectionManagerType || standardCollectionManagerType;

      return getReferenceDataDescription(
        collectionManagerType,
        ReferenceDataType.CollectionManager
      );
    },
    ...mapState({
      NZBNEntityType: () =>
        store.state.application.applicationData &&
        store.state.application.applicationData.businessDetails &&
        store.state.application.applicationData.businessDetails.business &&
        store.state.application.applicationData.businessDetails.business
          .entityTypeCode,
      NZBNID: (state: IApplicationState) =>
        state.applicationData &&
        state.applicationData.businessDetails &&
        state.applicationData.businessDetails.business &&
        state.applicationData.businessDetails.business.nzbn,
      NZBNRegisterUniqueNumber: () =>
        store.state.application.applicationData &&
        store.state.application.applicationData.businessDetails &&
        store.state.application.applicationData.businessDetails.business &&
        store.state.application.applicationData.businessDetails.business
          .sourceRegisterUniqueIdentifier,
      businessType: (state: IApplicationState) =>
        state.applicationData &&
        state.applicationData.businessDetails &&
        state.applicationData.businessDetails.businessType,
    })
  },
  validations: {}
});
